import { render, staticRenderFns } from "./MomentFeedPage.vue?vue&type=template&id=c22a3be4&scoped=true&"
import script from "./MomentFeedPage.vue?vue&type=script&lang=js&"
export * from "./MomentFeedPage.vue?vue&type=script&lang=js&"
import style0 from "./MomentFeedPage.vue?vue&type=style&index=0&id=c22a3be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a3be4",
  null
  
)

export default component.exports